import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { ScanCvService } from '../scan-cv/services/scan-cv/scan-cv.service';

@Component({
  selector: 'app-scan-linkedin-result',
  templateUrl: './scan-linkedin-result.component.html',
  styleUrls: ['./scan-linkedin-result.component.css'],
})
export class ScanLinkedinResultComponent {
  @Input() scanResultData: any;
  cvScores: any = {};
  contentData: any;
  user: any;
  jobRanking: any = null;
  openLists: Record<string, boolean> = {};

  constructor(
    private content: FetchDataService,
    private translate: TranslateService,
    private scanCvService: ScanCvService,
    private router: Router
  ) {
    this.user = JSON.parse(localStorage.getItem('userInfo')!);
    const navigate = this.router.getCurrentNavigation();
    if (navigate?.extras.state) {
      const state = navigate.extras.state;
      const formData = new FormData();
      formData.append('linkedin', state['data']);
      if (state['jobTarget'] || state['jobDescription']) {
        const jobJson = JSON.stringify({
          jobTarget: state['jobTarget'] ?? '',
          jobDescription: state['jobDescription'] ?? '',
        });
        formData.append('job', new Blob([jobJson], { type: 'application/json' }));
      }
      if (state['lang']) {
        formData.append('lang', state['lang']);
      }

  this.scanCvService.scanLinkedInProfile(formData).subscribe((res: any) => {
  const formatData = res.formatResponse ?? res;
  this.scanResultData = formatData;
  this.jobRanking = res.jobRankingResponse ?? null;

  const manualScore = this.calculateScore(this.scanResultData);

  this.cvScores.total = this.jobRanking?.overallScore != null
    ? parseFloat(((this.jobRanking.overallScore + manualScore) / 2).toFixed(1))
    : manualScore;

  this.cvScores.headline   = this.calculateScore(formatData.headline);
  this.cvScores.summary    = this.calculateScore(formatData.summary);
  this.cvScores.experience = this.calculateScore(formatData.experience);
  this.cvScores.education  = this.calculateScore(formatData.education);
  this.cvScores.technical  = this.calculateScore(formatData.technical);
});
    }
  }

  ngOnInit(): void {
    this.loadContent(this.translate.currentLang);
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadContent(event.lang);
    });
  }

  loadContent(lang: string): void {
    this.content.getContentData(lang, 'scan-linkedin-result').subscribe({
      next: (data) => {
        this.contentData = data;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  toggleList(key: string): void {
    this.openLists[key] = !this.openLists[key];
  }

  getCircleDash(score: number): string {
    const circumference = 2 * Math.PI * 15.9;
    const filled = (score / 100) * circumference;
    return `${filled} ${circumference}`;
  }

  getCheckIcon(fieldName: string): string {
    const fieldValue = this.findFieldValue(this.scanResultData, fieldName);
    if (fieldValue === 0) {
      return 'assets/icon/wrong-check.png';
    } else if (fieldValue === 1) {
      return 'assets/icon/right check.png';
    } else {
      return 'assets/icon/wrong-check.png';
    }
  }

  private findFieldValue(data: any, fieldName: string): any {
    if (data === null || data === undefined) {
      return undefined;
    }

    if (typeof data === 'object') {
      for (const key in data) {
        if (key === fieldName) {
          return data[key];
        }
        const nestedValue = this.findFieldValue(data[key], fieldName);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }

    if (Array.isArray(data)) {
      for (const item of data) {
        const nestedValue = this.findFieldValue(item, fieldName);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }

    return undefined;
  }

  calculateScore(data: any): number {
    let total = 0;
    let count = 0;

    function traverseAndScore(section: any) {
      if (Array.isArray(section)) {
        section.forEach((item) => traverseAndScore(item as any));
      } else {
        Object.values(section).forEach((value) => {
          if (typeof value === 'number') {
            total += value;
            count++;
          } else {
            traverseAndScore(value as any);
          }
        });
      }
    }

    traverseAndScore(data);
    return count === 0 ? 0 : parseFloat(((total / count) * 100).toFixed(1));
  }

  getTitleAndDescription(
    section: string,
    key: string
  ): { title: string; description: string } {
    if (!this.contentData) return { title: '', description: '' };

    const sectionData = this.contentData[section];

    if (Array.isArray(sectionData)) {
      for (const entry of sectionData) {
        if (entry[key]) {
          return {
            title: entry[key].title,
            description: entry[key].description,
          };
        }
      }
    } else if (sectionData && sectionData[key]) {
      return {
        title: sectionData[key].title,
        description: sectionData[key].description,
      };
    }

    return { title: '', description: '' };
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}